import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse,HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { ResetPasswordDto,ForgotPassword, User } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string, usertype: number) {
        return this.http.post<any>(`${environment.apiUrl}/api/Authenticate/Login`, { username, password, usertype })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                return user;
            }));
    }
    signup(user: User) {
        const formdata = new FormData();
        let params = new HttpParams().set('username', '');
        for (const key of Object.keys(user)) {
            const value = user[key];
            formdata.append(key, value);
        }

        return this.http.post<any>(`${environment.apiUrl}/api/Authenticate/Register`, formdata,{
            headers: { Accept: 'multipart/form-data' },
            params: params
        })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                return user;
            }));
    }
    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
    userUpdate(user: User) {
        return this.http.post<any>(`${environment.apiUrl}/api/Authenticate/Update`, user)
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('currentUser', JSON.stringify(user));
                //this.currentUserSubject.next(user);
                return user;
            }));
    }
    updatePreferences(user: User) {
        return this.http.post<any>(`${environment.apiUrl}/api/Authenticate/updatepref`, user)
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('currentUser', JSON.stringify(user));
                //this.currentUserSubject.next(user);
                return user;
            }));
    }
    getUser(cuser: User) {
        return this.http.post<any>(`${environment.apiUrl}/api/Authenticate/GetUser`, cuser)
            .pipe(map(user => {
                user.token=cuser.token;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                return user;
            }));
    }
    getUsers() :Observable<any>{
        return this.http.get<any>(`${environment.apiUrl}/api/Authenticate/GetUsers`)
            .pipe(map(user => {
                return user;
            }));
    }

    profileUpdate(user: User) {
        return this.http.post<any>(`${environment.apiUrl}/api/Authenticate/UpdateProfile`, user)
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('currentUser', JSON.stringify(user));
                //this.currentUserSubject.next(user);
                return user;
            }));
    }
    updateProfile(userDetails: any) {
        const formdata = new FormData();
        let params = new HttpParams().set('username', '');

        for (const key of Object.keys(userDetails)) {
            const value = userDetails[key];
            formdata.append(key, value);
        }
        return this.http.post<any>(`${environment.apiUrl}/api/Authenticate/UpdateProfile`, formdata, {
                headers: { Accept: 'multipart/form-data' },
                params: params
            })
            .pipe(map(result => {
                localStorage.setItem('currentUser', JSON.stringify(result));
                this.currentUserSubject.next(result);
                    return result;
                })
            );
    }

    public forgotPassword = (route: string, body: ForgotPassword) => {
       // return this.http.post(this.createCompleteRoute(route, this._envUrl.urlAddress), body);
       return this.http.post<any>(`${environment.apiUrl}/api/Authenticate/ForgotPassword`, body);
      }
    public resetPassword = (route: string, body: ResetPasswordDto) => {
        return this.http.post<any>(`${environment.apiUrl}/api/Authenticate/ResetPassword`, body);
    }
    // Handle API errors
    handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(
            'Something bad happened; please try again later.');
    };
    private log(message: string) {
        console.log(message);
    }
}